<template>
  <div>
    <div class="background-blue black-border" style="padding: 100px 0">
      <div class="card-wrapper">
        <b-row style="align-items: center">
          <b-col sm="12" md="6">
            <!-- Image -->
            <router-link to="/grades">
              <img src="@/assets/images/home_grades.jpg" alt="petrolifera" class="img-fluid" />
            </router-link>
          </b-col>
          <b-col sm="12" md="6" class="text-grades-wrap">
            <h2>{{ content.home.home_grades_titulo }}</h2>
            <p>{{ content.home.home_grades_texto }}</p>
          </b-col>
        </b-row>
      </div>
    </div>
    <b-row style="flex-flow: column; margin: 50px auto; justify-content: center">
      <VueSlickCarousel :responsive="responsive" v-bind="settings">
        <div>
          <img src="@/assets/images/slider-foto1.png" class="img-fluid" alt="petrolifera" />
        </div>
        <div>
          <img src="@/assets/images/slider-foto2.png" class="img-fluid" alt="petrolifera" />
        </div>
        <div>
          <img src="@/assets/images/slider-foto3.png" class="img-fluid" alt="petrolifera" />
        </div>
        <div>
          <img src="@/assets/images/slider-foto4.png" class="img-fluid" alt="petrolifera" />
        </div>
        <div>
          <img src="@/assets/images/slider-foto5.png" class="img-fluid" alt="petrolifera" />
        </div>
        <div>
          <img src="@/assets/images/slider-foto6.png" class="img-fluid" alt="petrolifera" />
        </div>
        <div>
          <img src="@/assets/images/slider-foto7.png" class="img-fluid" alt="petrolifera" />
        </div>
        <div>
          <img src="@/assets/images/slider-foto8.png" class="img-fluid" alt="petrolifera" />
        </div>
        <div>
          <img src="@/assets/images/slider-foto9.png" class="img-fluid" alt="petrolifera" />
        </div>
      </VueSlickCarousel>
    </b-row>
    <b-row class="card-wrapper catalogo " style="align-items: center;">
      <b-col sm="7" md="8" lg="9">
        <h2 style="margin-bottom: 20px">{{ content.home.home_catalogo_titulo }}</h2>
        <p style="padding-bottom:50px">{{ content.home.home_catalogo_texto }}</p>
      </b-col>
      <b-col sm="5" md="4" lg="3">
        <!-- Image -->
        <a :href="`${publicPath}catalogo.pdf`" download="download">
          <img src="@/assets/images/catalogo.jpg" alt="catalogo" class="img-fluid" />
        </a>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

// Json Content
import json from "../assets/content.json";

export default {
  name: "Destaques",
  components: { VueSlickCarousel },
  data() {
    return {
      content: json,
      publicPath: process.env.BASE_URL,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            draggable: true,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
      settings: {
        dots: true,
        arrows: true,
        dotsClass: "slick-dots custom-dot-class",
        edgeFriction: 0.35,
        swipe: true,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    };
  },
  // created() {
  //   fetch("https://www.sibrol.com.br/content.json", {
  //     headers: {
  //       "Content-Type": "application/json",
  //       "Access-Control-Allow-Origin": "http://localhost:8080/",
  //       "Access-Control-Allow-Headers": "Content-Type, Authorization",
  //       "Access-Control-Allow-Credentials": "true",
  //     },
  //   })
  //     .then((r) => r.json())
  //     .then((json) => {
  //       this.content = json;
  //     });
  // },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_standard.scss";

h2 {
  margin-top: 20px;
  color: $secondary;
  text-align: left;
}

.text-space-mobile {
  @media (max-width: 768px) {
    margin-bottom: 100px;
  }
}

.black-border {
  border-top: 10px solid $secondary;
  border-bottom: 10px solid $secondary;
}

.background-blue {
  background-color: $primary-light-background;
}

.card-wrapper {
  border-radius: 5px;
  margin: 0 auto;

  @media (min-width: 1200px) {
    padding: 50px;
  }

  .text-grades-wrap {
    padding: 0 40px;
  }

  img {
    box-shadow: 10px -10px 0px $secondary;
    //width: 90%;
  }

  &.catalogo {
    background-color: transparent;
    text-align: center;

    img {
      height: 300px;
    }
  }
}
.img-shadow-blue {
  box-shadow: 20px -20px 0px $primary;
}
</style>
